LS.util.route({
	'account': {
		'$guard:eval': {
			'views': {
				'$index': {
					':load': 'account.views',
					':unload': 'account.views:unload'
				}
			}
		}
	}
});